import { useTranslation } from 'react-i18next';

import '../styles/WorkoutStyles.css';

function Workout(props) {
  const { t } = useTranslation();
  let exercises;
  if (props.exercises?.length < 8) {
    exercises = [...props.exercises, ...Array(8 - props.exercises.length)];
  } else {
    exercises = props.exercises;
  }

  const halfLength = Math.ceil(exercises.length / 2);

  return (
    <section aria-labelledby="exercises-details-heading">
      <h2 id="exercises-details-heading" aria-hidden="true" className="visuallyHidden">
        {t('exercises.details')}
      </h2>
      <div className={props.equipment?.length > 0 ? 'workout' : 'workout no-equipment'}>
        {props.equipment?.length > 0 && (
          <section className="container exercises" aria-labelledby="equipment-heading">
            <div className="title">
              <h3 id="equipment-heading">{t('M054')}</h3>
            </div>
            <div className="body">
              <ol className="list" aria-label={t('exercises.list')}>
                {props.equipment.map((item) => {
                  return (
                    <li className="item transparent-button" key={item}>
                      <div className="step">{item}</div>
                    </li>
                  );
                })}
              </ol>
            </div>
          </section>
        )}
        <section aria-labelledby="exercises-heading" className="container equipment">
          <div className="title">
            <h3 id="exercises-heading">{t('M053')}</h3>
          </div>
          <div className="body">
            <div className="list">
              <div className="first column">
                {exercises.slice(0, halfLength).map((item, index) =>
                  item ? (
                    // The list is padded with empty slots and names can repeat, index is the identity.
                    // eslint-disable-next-line react/no-array-index-key
                    <div className="item" key={index}>
                      <div className="number">{index + 1}</div>
                      {item}
                    </div>
                  ) : (
                    // eslint-disable-next-line react/no-array-index-key
                    <div className="item" key={index} />
                  )
                )}
              </div>
              <div className="second column">
                {exercises.slice(halfLength).map((item, index) =>
                  item ? (
                    // eslint-disable-next-line react/no-array-index-key
                    <div className="item" key={index + halfLength}>
                      <div className="number">{index + 1 + halfLength}</div>
                      {item.replaceAll('&amp;', '&')}
                    </div>
                  ) : (
                    // eslint-disable-next-line react/no-array-index-key
                    <div className="item" key={index + halfLength} />
                  )
                )}
              </div>
            </div>
          </div>
        </section>
      </div>
    </section>
  );
}

export default Workout;
